import { render } from "./LessonBoxComponent.vue?vue&type=template&id=a8728292&scoped=true"
import script from "./LessonBoxComponent.vue?vue&type=script&lang=js"
export * from "./LessonBoxComponent.vue?vue&type=script&lang=js"

import "./LessonBoxComponent.vue?vue&type=style&index=0&id=a8728292&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8728292"]])

export default __exports__